import { customReviewTestletSubRoutes } from '../../routes';

export const TestletTypes = {
  PENDING: {
    key: 'PENDING',
    types: ['2', '2A', '2C'],
    linkTo: customReviewTestletSubRoutes.pending.to
  },
  UNDER_REVISION: {
    key: 'UNDER_REVISION',
    types: ['2B'],
    linkTo: customReviewTestletSubRoutes.revision.to
  },
  APPROVED: {
    key: 'APPROVED',
    types: ['3', '4'],
    linkTo: customReviewTestletSubRoutes.approved.to
  },
  PUBLISHED: {
    key: 'PUBLISHED',
    types: ['5'],
    linkTo: customReviewTestletSubRoutes.published.to
  },
  FLAGGED: {
    key: 'FLAGGED',
    types: ['6'],
    linkTo: customReviewTestletSubRoutes.flagged.to
  }
};
